/**
 * Numéro de contact générique affiché dans le header
 * pour les agences des groupes garants.
 */
export const GENERIC_CONTACT_PHONE = {
  display: '04 84 98 02 00',
  tel: '+33484980200',
} as const;
